<template>
  <!-- 作品组件 -->
  <view>
    <view class="SL_CB_list_top">
      <view>
        <!-- <img class="SLCB_list_top_hot" src="../assets/publick_zptj2.png" /> -->
        <span class="SLCB_list_top_definition">{{ item.videoDefinition }}</span>
        <view class="SLCB_list_top_button">
          <view>
            <span class="SLTB_bf">
              <img src="../assets/index_bfl.png" />
              <text>{{ item.plays }}</text>
            </span>
            <span class="SLTB_dz">
              <img src="../assets/index_dzl.png" />
              <text>{{ item.likes }}</text>
            </span>
          </view>
          <view class="SLTB_time">{{ item.videoTime }}</view>
        </view>
      </view>
      <img :src="item.coverSheet" style="width: 305px; height: 180px" />
    </view>
    <P class="SL_CB_list_title">{{ item.title }}</P>
    <P class="SL_CB_list_type">{{ item.category1 }}-{{ item.category2 }}
      {{ item.publishAddress ? item.publishAddress : "未知" }}
      {{ com_date.com_date.timestamp_string(item.createTime, true, "-", ":") }}
    </P>
    <view class="SL_CB_list_user" @click.stop="toUser">
      <!-- <img class="SL_CB_list_user_img" src="../assets/logo.png" /> -->
      <img class="SL_CB_list_user_img" :src="item.avatar ? item.avatar : require('../assets/logo.png')" />

      <span class="SL_CB_list_user_name">{{ item.nickName }}</span>
      <!-- <img class="SL_CB_list_user_hy1" src="../assets/publick_huiyuan.png" alt="">
			<img class="SL_CB_list_user_hy2" src="../assets/publick_huiyuan2.png" alt=""> -->
    </view>
  </view>
</template>

<script setup>
import com_date from "@/assets/js/common.js";
const props = defineProps({
  item: {
    type: Object,
  },
});
const toUser = () => {
  open("/ShadowComposerHomepage?id=" + props.item.createUserId, "_blank");
}
</script>

<style scoped>
.SL_CB_list_top {
  display: block;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}

.SL_CB_list_top>img {
  width: 100%;
}

.SL_CB_list_top>view {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.SLCB_list_top_hot {
  width: 0.22rem;
  height: 0.22rem;
  position: absolute;
  top: 0.12rem;
  left: 0.16rem;
}

.SLCB_list_top_definition {
  position: absolute;
  top: 0.15rem;
  right: 0.17rem;
  padding: 0.02rem 0.06rem;
  background: rgba(51, 51, 51, 0.5);
  border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
  color: #fff;
}

.SLCB_list_top_button {
  width: calc(100% + 0.06rem);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  left: 0;
  /* padding: 0.14rem 0.16rem; */
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8));
  padding-right: 0.16rem;
  height: 0.4rem;
  line-height: 0.4rem;
  border-radius: 0.12rem;
}

.SLTB_bf,
.SLTB_dz,
.SLCB_list_top_button>view {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.SLTB_bf {
  margin-right: 0.2rem;
}

.SLTB_bf>img,
.SLTB_dz>img {
  width: 0.14rem;
  margin-right: 0.04rem;
}

.SLTB_bf>text,
.SLTB_dz>text {
  font-size: 0.12rem;
  color: #ffffff;
}

.SLTB_time {
  color: #fff;
  font-size: 0.12rem;
}

.SL_CB_list_title {
  font-size: 0.14rem;
  color: #000;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 0.12rem;
}

.SL_CB_list_type {
  font-size: 0.12rem;
  color: #86909c;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 0.04rem;
}

.SL_CB_list_user {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 0.12rem;
}

.SL_CB_list_user_img {
  width: 0.24rem;
  height: 0.24rem;

  margin-right: 0.08rem;
  border-radius: 50%;
}

.SL_CB_list_user_name {
  font-size: 0.12rem;
  color: #000;
  margin-right: 0.08rem;
}

.SL_CB_list_user_hy1,
.SL_CB_list_user_hy2 {
  width: 0.16rem;
  margin-right: 0.06rem;
}
</style>
